import ENDPOINT from 'constants/endPoint';
import axiosClient from 'utils/axios';

export default {
  async updatePlaceOtaCredentials({ placeId, data }) {
    const path = ENDPOINT.UPDATE_PLACE_OTA_CREDENTIALS(placeId);

    await axiosClient.put(path, data);
  },
};
